import { ProductFeatureModel } from "@api/mappers/products.mapper";

import { attemptMethod } from "@utils/general";

export const displayFeature = (feature: ProductFeatureModel): string => {
    if (!feature) return "";

    const featureValue = attemptMethod(
        () => feature.featureValues.map(f => f.formattedValue || "").join(", "),
        "",
    );
    const featureUnit = !!feature.unit?.name ? ` ${feature.unit?.name}` : "";

    return `${featureValue}${featureUnit}`;
};
